<template>
  <div>
    <h1>Alliance</h1>
    <div v-if="isAdmin">
      <label for="title">Address: </label>
      <input type="text" v-model="servername" class="w3-input w3-border" style="width: 70%;" placeholder="example.org" required /><br>
      <button @click="addServer" class="w3-button w3-blue">Add</button>
    </div>
    
    <div v-if="loading">Loading...</div>
    <div v-else-if="error">Error: {{ error }}</div>
    <table v-else style="width:100%">
      <tr v-for="server in servers" :key="server.id">
        <td>{{ server.ID }}</td>
        <td><a :href="`http://${server.name}`">{{ server.name }}</a></td>
        <td>{{ server.CreatedAt}}</td>
        <td>
          <button v-if="isAdmin" @click="deleteServer(server.name)" style="color: Red;">Delete</button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import config from '../config';

export default {
  name: 'ServerList',
  mounted() {
    const isAdmin = sessionStorage.getItem('is_admin');
    this.isAdmin = isAdmin === '1'; // Set true if `is_admin` is 1
  },
  setup() {
    const servers = ref([]);
    const loading = ref(true);
    const error = ref(null);
    const servername = ref("");

    const token = sessionStorage.getItem("jwt");

    const addServer = async () => {
      const formData = new FormData();
      formData.append("address", servername.value);
      try {
        const response = await fetch(`${ config.apiBaseUrl }/admin/server/add`, {
          method: "POST",
          credentials: 'include',
          headers: {
            "Authorization": `Bearer ${token}`,
          },
          body: formData,
        });
        if (!response.ok) {
          throw new Error('Failed to perform the action');
        }
        alert('Added!');
        fetchServers();
      } catch (err) {
        alert(`Error: ${err.message}`);
      }
    }

    const fetchServers = async () => {
      try {
        const response = await fetch(`${ config.apiBaseUrl }/alliance`); // Replace with your actual API endpoint
        if (!response.ok) {
          throw new Error('Failed to fetch server list');
        }
        const data = await response.json();
        servers.value = data;
      } catch (err) {
        error.value = err.message;
      } finally {
        loading.value = false;
      }
    };

    const deleteServer = async (name) => {
      if (window.confirm("Are you sure you want to delete this server?")) {
        try {
          const response = await fetch(`${ config.apiBaseUrl }/admin/server/delete/${name}`, {
            method: 'DELETE',
            headers: {
              "Authorization": `Bearer ${token}`,
            }
          });
          if (!response.ok) {
            throw new Error('Failed to perform the action');
          }
          alert('Server deleted successfully!');
          fetchServers();
        } catch (err) {
          alert(`Error: ${err.message}`);
        }
      } else {
        console.log("Cancelled.");
      }
    };

    onMounted(fetchServers);

    return {
      servername,
      addServer,
      deleteServer,
      servers,
      loading,
      config,
      error
    };
  }
};
</script>

<style scoped>
/* Optional styling */
h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 1em;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1em;
}
</style>
